<div class="calculator__right second-right middle">
  <div>
    <div class="calculator__right-top">
      <div class="calculator__right-title">Получатель</div>
    </div>

    <el-form-item prop="consignee.consigneeType">
      <el-form-item
        prop="dataForm.consignee.consigneeType"
      >
        <el-radio-group
          class="calculator__payer__buttons calculator__payer__buttons_type_three mb-40"
          v-model="dataForm.consignee.consigneeType"
          @change="consigneeTypeChange"
        >
          <el-radio-button
            v-for="option in optionsPersonType"
            :key="option.value"
            :label="option.value"
            class="calculator__payer__button"
            @click="e => e.target.parentNode.classList.remove('is-focus')"
          >{{ option.label }}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      
    </el-form-item>
    <el-form-item
      v-if="dataForm.consignee.consigneeType != 0"
      class="margin-bottom--30-p"
    >
      <el-form-item
        prop="consignee.innConsignee"
        class="calculator__form-item"
      >
        <el-input v-if="!dataForm.consignee?.cityTo.includes('(Москва)')" :placeholder="dataForm.consignee.consigneeType === 2 ? 'ИНН/БИН' : 'ИНН'" type="text" autocomplete="on" v-model="dataForm.consignee.innConsignee" v-mask="INN_MASK" :maxlength="dataForm.consignee.consigneeType === 2 ? 12 : 10" @change="getNameOrganization('consignee', dataForm.consignee.innConsignee)" />
      </el-form-item>

      <el-form-item
        v-if="dataForm.consignee.consigneeType == 1"
        prop="consignee.kppConsignee"
        class="calculator__form-item"
      >
        <el-input v-if="!dataForm.consignee?.cityTo.includes('(Москва)')" placeholder="КПП" type="text" autocomplete="on" v-model="dataForm.consignee.kppConsignee" v-mask="KPP_MASK" @change="getNameOrganization('consignee', dataForm.consignee.kppConsignee)" />
      </el-form-item>

      <el-form-item
        prop="consignee.name"
        class="calculator__form-item"
      >
        <el-input :disabled="dataForm.consignee?.cityTo.includes('(Москва)')" placeholder="Наименование организации" type="text" autocomplete="given-name" v-model="dataForm.consignee.name" />
      </el-form-item>
    </el-form-item>

    <el-form-item
      v-if="dataForm.consignee.consigneeType == 0"
      class="margin-bottom--30-p"
    >
        <el-form-item prop="consignee.surnameConsignee" class="calculator__form-item">
          <el-autocomplete
            v-model="dataForm.consignee.surnameConsignee"
            :fetch-suggestions="getSurNameSearch"
            @input="getSurName"
            clearable
            placeholder="Фамилия"
            @keyup="dataForm.consignee.surnameConsignee = limitInput(dataForm.consignee.surnameConsignee)"
            :trigger-on-focus="false"
          />
        </el-form-item>
        <el-form-item prop="consignee.firstNameConsignee" class="calculator__form-item">
          <el-autocomplete
            v-model="dataForm.consignee.firstNameConsignee"
            @keyup="dataForm.consignee.firstNameConsignee = limitInput(dataForm.consignee.firstNameConsignee)"
            :fetch-suggestions="getFirstNameSearch"
            @input="getName"
            clearable
            placeholder="Имя"
            :trigger-on-focus="false"
          />
        </el-form-item>
        <el-form-item prop="consignee.secondNameConsignee" class="calculator__form-item">
          <el-autocomplete
            v-model="dataForm.consignee.secondNameConsignee"
            :fetch-suggestions="getSecondNameSearch"
            @keyup="dataForm.consignee.secondNameConsignee = limitInput(dataForm.consignee.secondNameConsignee)"
            @input="getSecondName"
            clearable
            autocomplete="additional-name"
            placeholder="Отчество"

            :trigger-on-focus="false"
          />
        </el-form-item>
    </el-form-item>

    <el-form-item class="form-group">
        <el-form-item
          label="Телефон"
          prop="consignee.phoneConsignee"
          class="calculator__form-item"
          v-if="!dataForm.consignee?.cityTo.includes('(Москва)')"
        >
          <el-input
            v-model="dataForm.consignee.phoneConsignee"
            v-mask="PHONE_MASK"
            type="tel"
            :formatter="(value) => `${value}`.replace(/\(89/g, '9')"
            :placeholder="PHONE_PLACEHOLDER"
            @change="checkPhone"
          />
        </el-form-item>
        <el-form-item
          type="email"
          label="Эл. почта"
          class="calculator__form-item"
          v-if="!dataForm.consignee?.cityTo.includes('(Москва)')"
          prop="consignee.emailConsignee"
          :required="dataForm.consignee.consigneeType"
          >
          <!-- prop="consignee.emailConsignee" -->
          
          <el-input type="text" autocomplete="given-name" v-model="dataForm.consignee.emailConsignee" />
        </el-form-item>
    </el-form-item>
  </div>

  <!-- <div class="bord_button">
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-back')"
      >
        Назад
      </el-button>
    </el-form-item>
    <el-form-item>
      <el-button
        class="button_send"
        type="primary"
        @click="$emit('click-button-next')"
      >
        Далее
      </el-button>
    </el-form-item>
  </div> -->
</div>
<div class="calculator__center-line"></div>